import { AppState } from 'app/store';

export const getAppInfo = (state: AppState) => state.electron.info;

export const getPlatform = (state: AppState) => state.electron.info?.platform;
